export const COMMON_ACTIONS = {
  LOADING: "LOADING",
  SERVER_FAILURE: "SERVER_FAILURE",
};



// WEBPACK FOOTER //
// ./src/components/scanBarcode/constants/ActionType.js